import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Button, Group, Modal, TextInput, Text } from '@mantine/core';

import { useAddProfile } from '../../api/addProfile';
import { useProfileForm } from '../../hooks/useProfileForm';

import { Departments } from '@/types';

type Props = {
  department: Departments;
};

export const AddModal = NiceModal.create(({ department }: Props) => {
  const modal = useModal();
  const form = useProfileForm({ department });

  const { mutate, isLoading } = useAddProfile({ onSuccess: modal.hide, department });

  return (
    <Modal
      centered
      overlayProps={{ opacity: 0.4, blur: 1.5 }}
      opened={modal.visible}
      onClose={() => modal.remove()}
      title="New profile"
    >
      <form onSubmit={form.onSubmit((data) => mutate(data))}>
        <Text mt="sm" mb="xs" size="sm">
          Name
        </Text>
        <TextInput required placeholder="Название" {...form.getInputProps('name')} mb="xl" />
        <Text mb="xs" size="sm">
          Department
        </Text>
        <TextInput required {...form.getInputProps('department')} disabled mb="xl" />
        <Text mb="xs" size="sm">
          OP
        </Text>
        <TextInput required placeholder="ОП" {...form.getInputProps('op')} mb="xl" />
        <Group justify="right">
          <Button loading={isLoading} type="submit">
            Add
          </Button>
        </Group>
      </form>
    </Modal>
  );
});
